import styled from 'styled-components';
import { cssHelpers } from '~helpers';
var MessageWrapper = styled.span.withConfig({
  displayName: "MessageWrapper",
  componentId: "sc-7jqun5-0"
})(["", " display:block;font-weight:700;text-align:center;width:100%;"], cssHelpers.textOverflow);
export default MessageWrapper;